import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = 'website',
  image = 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/chzo27xv_006.jpg',
  jsonLd
}) => {
  const siteUrl = 'https://greenfrogutilities.co.uk';
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" data-rh="true" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" data-rh="true" content={title} />
      <meta property="og:description" data-rh="true" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" data-rh="true" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Structured Data */}
      {jsonLd && jsonLd.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
